import { useRef, type MouseEvent, type PointerEvent } from 'react';

/**
 * Poteg s prstom ali miško levo/desno (več kot 40 px) pokliče {@code pojdi(1)} ali {@code pojdi(-1)}; klik, ki
 * konča poteg, ne pride do elementov pod njim (npr. ne odpre celozaslonskega ogleda).
 */
export function usePoteg(pojdi: (smer: number) => void) {
  const zacetek = useRef<number | null>(null);
  const potegnjeno = useRef(false);
  return {
    onPointerDown: (e: PointerEvent) => {
      zacetek.current = e.clientX;
      potegnjeno.current = false;
    },
    onPointerUp: (e: PointerEvent) => {
      const dx = zacetek.current === null ? 0 : e.clientX - zacetek.current;
      zacetek.current = null;
      if (Math.abs(dx) > 40) {
        potegnjeno.current = true;
        pojdi(dx < 0 ? 1 : -1);
      }
    },
    onClickCapture: (e: MouseEvent) => {
      if (potegnjeno.current) {
        potegnjeno.current = false;
        e.stopPropagation();
      }
    },
  };
}
